// Mirrors backend/quote_logic.py compute_totals
export const DEFAULT_SOLUTION_TEXT = 'Vapelarm hjälper skolor att upptäcka misstänkt vejping på elevtoaletter och andra utsatta utrymmen. Sensorerna identifierar luftförändringar som kan indikera användning av e-cigaretter och skickar notifieringar till berörd personal. Händelser kan följas upp i Vapelarm Cloud. Systemet använder varken kameror eller mikrofoner.';

export const INSTALLED_BY = { vapelarm: 'Vapelarm', customer: 'Kunden', external: 'Extern installatör' };

const MONTHLY = ['mån', 'man', 'månad', 'manad', 'mån.'];
const rowTotal = (i) => (parseFloat(i.quantity) || 0) * (parseFloat(i.unit_price) || 0);

export function computeQuoteTotals(f) {
  const hw = (f.hardware_items || []).reduce((s, i) => s + rowTotal(i), 0);
  const acc = (f.accessory_items || []).reduce((s, i) => s + rowTotal(i), 0);
  const lic = (f.license_items || []).reduce((s, i) => s + rowTotal(i) * (MONTHLY.includes((i.unit || '').trim().toLowerCase()) ? 12 : 1), 0);
  const disc = Math.max(0, Math.min(100, parseFloat(f.discount_percent) || 0));
  const discAmt = Math.round(hw * disc) / 100;
  const install = parseFloat(f.installation_cost) || 0;
  const oneTime = hw - discAmt + acc + install;
  const sumEx = oneTime + lic;
  const vat = Math.round(sumEx * 25) / 100;
  return { hw, acc, lic, disc, discAmt, install, oneTime, recurring: lic, sumEx, vat, sumInkl: sumEx + vat };
}

export function renewalText(f) {
  if (f.auto_renew === undefined) return '';
  if (!f.auto_renew) return 'Avtalet förlängs inte automatiskt.';
  return `Avtalet förlängs automatiskt med ${f.renewal_months || 12} månader om det inte sägs upp senast ${f.notice_days || 90} dagar före pågående avtalsperiods slut.`;
}

export const sek = (v) => `${Math.round(v || 0).toLocaleString('sv-SE')} kr`;
